interface ParamsProps {
  iconType: string;
  isFirstChecked: string;
}

interface ReadParamProps {
  noCardsRead: boolean;
}

export class AdminByScheduleParams {
  static params: ParamsProps;
  static readParam: ReadParamProps;
}
